import React from 'react';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const { language, t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12" style={{ backgroundColor: 'var(--brown-dark)', color: 'white' }}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ color: 'var(--amber-light)' }}>
              SALOON & BEER
            </h3>
            <p className="text-white/80 leading-relaxed">
              {language === 'ro' 
                ? 'Pub-ul tău pentru o bere bună în Chișinău'
                : 'Your pub for good beer in Chișinău'
              }
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ color: 'var(--amber-light)' }}>
              {t.contact.title}
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin size={18} className="mt-1" style={{ color: 'var(--amber-light)' }} />
                <span className="text-sm text-white/80">
                  {language === 'ro' ? contactInfo.address : contactInfo.addressEn}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={18} style={{ color: 'var(--amber-light)' }} />
                <a
                  href="tel:+37378015880"
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ color: 'var(--amber-light)' }}>
              {t.contact.hours}
            </h4>
            <p className="text-white/80">{t.contact.hoursDetails}</p>
            <a
              href={contactInfo.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-sm hover:opacity-70 transition-opacity"
              style={{ color: 'var(--amber-light)' }}
            >
              <ExternalLink size={16} />
              {t.contact.getDirections}
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-sm text-white/60">
            © {currentYear} SALOON & BEER. {t.footer.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;